export default __webpack_public_path__ + "static/media/img_1.b4d87bfc.svg";